import { useGetProductBySlug } from "../api/queries/productQueries";
import { useBookingStateQuery } from "./useCart";

export const useProductDetail = (
  slug: string,
  opts?: {
    bookingId?: string;
    loadLocal?: boolean;
  },
) => {
  const {
    data: productData,
    isLoading: isProductLoading,
    isError: isProductError,
  } = useGetProductBySlug({ slug });

  // const {
  //   data: bookingData,
  //   isLoading: isBookingLoading,
  //   isError: isBookingError,
  // } = useFetchBooking(Number(bookingId));
  const { data: bookingData, isLoading: isBookingLoading } =
    useBookingStateQuery({
      bookingId: opts?.bookingId,
      shouldFetch: opts?.loadLocal ? false : !!opts?.bookingId,
    });
  return {
    isLoading: isProductLoading || isBookingLoading || !productData,
    isError: isProductError,
    productData,
    bookingData,
  };
};
